<template>
    <div class="form-group" :class="{'has-error': error }">
        <label v-if="label" :for="name" class="label">{{ label }}</label>
        <div class="field-group">
            <input
                class="text"
                :type="type"
                :value="value"
                :disabled="disabled"
                min="1"
                @input="updateValue"
                @change="updateValue"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
            >
            <Transition name="fade">
                <p v-show="error" class="error">{{ error }}</p>
            </Transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NumberInput',
        props: {
            name: {
                type: String,
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            value: {
                type: [Number, String],
                required: false,
                default: null,
            },
            error: {
                type: String,
                required: false,
                default: null,
            },
            type: {
                type: String,
                default: 'text',
                validate: val => ['text', 'number'].indexOf(val) !== -1,
            },
        },
        methods: {
            updateValue(event) {
                this.$emit('input', event.target.value);
            },
        },
    };
</script>
